import { sdk } from 'src/utilities/sdk';

export async function sendDinerWelcomeEmail(
  corpId: string,
  dinerId: string
): Promise<void> {
  const dinerWelcomeEmailLink = `/corps/${corpId}/diners/${dinerId}/sendWelcomeEmail`;

  await sdk.http.post(dinerWelcomeEmailLink, {});
}
